/**
 * 이용자보호 비전과 계획 (호주 법률 준수)
 */

import Seo from "@/components/seo/Seo";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle2, Shield, Target } from "lucide-react";

export default function UserProtection() {
  return (
    <>
      <Seo
        title="이용자보호 비전과 계획 — OZK News"
        description="OZK News 이용자보호 정책 및 계획"
        path="/user-protection"
      />

      <div className="min-h-screen bg-background">
        <div className="max-w-4xl mx-auto px-4 py-12">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-4">이용자보호 비전과 계획</h1>
            <p className="text-lg text-muted-foreground">
              안전하고 신뢰할 수 있는 플랫폼을 만들기 위한 우리의 약속
            </p>
          </div>

          <Alert className="mb-6">
            <Shield className="h-4 w-4" />
            <AlertDescription>
              본 정책은 호주 소비자법(Australian Consumer Law) 및 개인정보
              보호법(Privacy Act 1988)을 준수합니다.
            </AlertDescription>
          </Alert>

          <div className="space-y-6">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Target className="w-5 h-5" />
                  이용자보호 비전
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p className="text-muted-foreground">
                  OZK News는 호주 한인 커뮤니티가 안전하고 신뢰할 수 있는
                  환경에서 정보를 공유하고 거래할 수 있도록 최선을 다하겠습니다.
                </p>
                <div>
                  <h3 className="font-semibold mb-2">핵심 가치</h3>
                  <ul className="list-disc list-inside space-y-1 text-muted-foreground">
                    <li>투명성: 명확한 정책과 공정한 운영</li>
                    <li>안전성: 사용자 정보 및 거래 보호</li>
                    <li>책임성: 신속한 대응과 지속적 개선</li>
                  </ul>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <CheckCircle2 className="w-5 h-5" />
                  보호 계획
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div>
                  <h3 className="font-semibold mb-2">개인정보 보호</h3>
                  <ul className="list-disc list-inside space-y-1 text-muted-foreground">
                    <li>암호화된 데이터 저장 및 전송</li>
                    <li>최소한의 정보 수집 원칙</li>
                    <li>정기적인 보안 점검</li>
                  </ul>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">거래 안전</h3>
                  <ul className="list-disc list-inside space-y-1 text-muted-foreground">
                    <li>사기 방지 시스템 구축</li>
                    <li>신고 및 제재 체계 운영</li>
                    <li>안전 거래 가이드 제공</li>
                  </ul>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">콘텐츠 관리</h3>
                  <ul className="list-disc list-inside space-y-1 text-muted-foreground">
                    <li>부적절한 콘텐츠 자동 필터링</li>
                    <li>신고 시스템 운영</li>
                    <li>신속한 조치 및 피드백</li>
                  </ul>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}
